module.exports = __webpack_public_path__ + "img/PGSlot_Lobby_Frame.cda5d72c.png";